import * as angular from 'angular';
import { CreditGapsWizardStepperComponent } from './credit-gaps-wizard-stepper.component';
import { AssignIncompleteGradPlansStepComponent } from './steps/assign-incomplete-grad-plans/assign-incomplete-grad-plans.component';
import { DoFinalCheckStepComponent } from './steps/do-final-check/do-final-check.component';
import { GenerateProgramChangesExportStepComponent } from './steps/generate-program-changes-export/generate-program-changes-export.component';
import { InstructionsStepComponent } from './steps/instructions/instructions.component';
import { MonitorProgramChangesStepComponent } from './steps/monitor-program-changes/monitor-program-changes.component';
import { ReviewGapsByPriorityStepComponent } from './steps/review-gaps/review-gaps.component';
import { ReviewOtmStepComponent } from './steps/review-otm/review-otm.component';

export const CreditGapsWizardStepperModule = angular
  .module('creditGapsWizardStepperModule', [])
  .component('creditGapsWizardStepper', CreditGapsWizardStepperComponent)
  .component('creditGapsInstructionsStep', InstructionsStepComponent)
  .component('creditGapsAssignIncompleteGradPlansStep', AssignIncompleteGradPlansStepComponent)
  .component('creditGapsReviewOtmStep', ReviewOtmStepComponent)
  .component('creditGapsReviewGapsByPriorityStep', ReviewGapsByPriorityStepComponent)
  .component('creditGapsGenerateProgramChangesExportStep', GenerateProgramChangesExportStepComponent)
  .component('creditGapsMonitorProgramChangesStep', MonitorProgramChangesStepComponent)
  .component('creditGapsDoFinalCheckStep', DoFinalCheckStepComponent).name;
